import React, { useEffect, useState } from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useGetManagementCompanies } from 'hooks/useGetManagementCompanies';
import { noop } from 'lodash';

export type MGListSelectProps = SelectProps<any> & {
  allowClear?: boolean;
  onSelected?: (val: any) => void;
};

const MGListSelect = (props: MGListSelectProps) => {
  const { allowClear, onChange = noop,value, } = props;

  let [init, setInit] = useState(true);

  const { data } = useGetManagementCompanies();
  useEffect(() => {
    if (data) {
      const n = data?.length
      const defaultItem = data[n-1];
      if (defaultItem && value === undefined) {
        if (!allowClear || init) {
          onChange(defaultItem?.mgid);
          setInit(false);
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, onChange, value, allowClear]);

  const handleChange: SelectProps<any>['onChange'] = (value) => {
    onChange(value);
  };

  return (
    <Select allowClear onChange={handleChange} value={value} {...props}>
      {data?.map((company: any) => (
        <Select.Option value={company.mgid} key={company.mgid}>
          {company.mgname}
        </Select.Option>
      ))}
    </Select>
  );
};

export default MGListSelect;
